module.exports = __webpack_public_path__ + "img/activate_dp.af44bd52.svg";